import { render, staticRenderFns } from "./LoginView.vue?vue&type=template&id=6c28860a"
var script = {}
import style0 from "./LoginView.vue?vue&type=style&index=0&id=6c28860a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports